var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ jw74: _vm.isJw74 }},[_c(_vm.layout,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }